import type { Dictionary } from './en'

export const zh = {
  nav: { features: '功能', pricing: '价格', faq: '常见问题', account: '我的账户', signIn: '登录' },
  hero: {
    title: '为 Mac 而生的 Alt-Tab',
    tagline: 'macOS 切换应用，AppSwitch 让 ⌥Tab 切换窗口——所有窗口，包括同一个应用里打开的三个文稿。',
    download: '下载 Mac 版', seePricing: '查看价格',
    note: '免费 · macOS 15 或更高 · Apple 芯片与 Intel',
    hint: '按住 ⌥ 再按 Tab，松手即切换',
  },
  features: {
    heading: '为同时开着二十个窗口的人而做',
    sub: '按一下 ⌥Tab，全部展开。松手即到。',
    items: [
      { title: '按窗口，而不是按应用', body: 'macOS 的切换器在应用之间切换，AppSwitch 在窗口之间切换——包括同一个应用里打开的三个文稿。' },
      { title: '键盘优先', body: '⌥Tab 向前，⌥⇧Tab 向后，方向键在网格中移动。松开 ⌥，选中的窗口就来到最前。' },
      { title: '从不抢占焦点', body: '在你真正做出选择之前，原来的应用始终保持活跃。AppSwitch 常驻菜单栏，不在程序坞占位。' },
      { title: '实时预览', body: '看到的是每个窗口的真实内容，而不是笼统的应用图标。已最小化的窗口也直接出现在切换器里。' },
    ],
  },
  pricing: {
    heading: '一次购买，永久拥有。',
    sub: '切换器本身免费且完整——不是试用版，也没有阉割。Pro 增加两项需要许可证的功能。',
    free: '免费', pro: 'Pro', ribbon: '一次性购买',
    freePrice: '¥0', once: '一次性',
    freeSub: '告别 ⌘Tab 所需的一切。',
    proSub: '没有订阅，永不自动续费。',
    freeList: ['基于 ⌥Tab 的完整窗口切换器', '键盘与鼠标操作', '网格与列表两种视图', '菜单栏应用，无程序坞图标'],
    proList: ['免费版的全部功能', '每个窗口的实时预览', '切换器中包含已最小化的窗口', '每个许可证可用于两台 Mac'],
    download: '下载', buy: '获取 AppSwitch Pro', buyBusy: '正在打开付款页…',
    freeFoot: '无需账户，无需银行卡，永不过期。',
  },
  faq: {
    heading: '常见问题',
    items: [
      { q: '为什么 AppSwitch 需要辅助功能权限？', a: '这是 macOS 上唯一能让应用先于其他应用接管 ⌥Tab、列出你的窗口并将其中一个带到最前的方式。没有它，应用根本无法工作。你在系统设置中自行授予，也可随时撤销。' },
      { q: '这是订阅吗？', a: '不是。AppSwitch Pro 是一次性购买。不会自动续期，不会再次扣费，当前大版本的更新均包含在内。' },
      { q: '可以在几台 Mac 上使用？', a: '每个许可证两台。你随时可以在账户页面或应用内释放一个名额，所以换电脑从来不需要联系客服。' },
      { q: '我的窗口标题会被发送到什么地方吗？', a: '不会。任何窗口内容、窗口标题和按键都不会离开你的 Mac。应用唯一的网络请求是许可证校验，且仅在你购买 Pro 后才有。免费版从不联网。' },
      { q: '支持哪些 macOS 版本？', a: 'macOS 15 或更高版本，支持 Apple 芯片与 Intel。' },
    ],
  },
  listMode: {
    heading: '看窗口的两种方式',
    sub: '在菜单栏切换，或在切换器打开时按「,」键。',
    grid: { title: '网格视图，带预览', body: '真实内容的缩略图。适合靠画面内容辨认窗口的人。' },
    list: { title: '列表视图，完整标题', body: '紧凑的单列，每个窗口的完整标题一行放得下。适合同时开二十个终端，或文件名只有结尾不同的情况。' },
  },

  footer: { terms: '使用条款', privacy: '隐私政策' },
  consent: {
    text: '我们使用 Google Analytics 了解哪些页面有用。未经你同意，不会进行任何统计。详见我们的',
    privacyLink: '隐私政策', accept: '接受', decline: '拒绝',
  },
} satisfies Dictionary
